import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
/**
 * Переиспользуемый хук для логики открытия дропдаунов
 * Хранит одну переменную состояния, отдает ее и 2 коллбэка управления
 * */

export var useDropdownControls = function useDropdownControls() {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isOpen = _React$useState2[0],
      setOpen = _React$useState2[1];

  var handleToggle = React.useCallback(function () {
    setOpen(function (prev) {
      return !prev;
    });
  }, []);
  var handleClose = React.useCallback(function () {
    setOpen(false);
  }, []);
  return {
    isOpen: isOpen,
    handleToggle: handleToggle,
    handleClose: handleClose
  };
};